const teReo = {
  data () {
    return {
      'teReo': false
    }
  },
  mounted () {
    const url = new URL(window.location.href)

    if (url.searchParams.get('lang') === 'mi') {
      this.teReo = true
    } else {
      try {
        if (window.localStorage.getItem('mwlr-lang') === 'mi') {
          this.teReo = true
        }
      } catch (error) {
        console.log(error)
      }
    }
  },
  methods: {
    toggleTeReo () {
      this.teReo = !this.teReo
      try {
        if (this.teReo) {
          window.localStorage.setItem('mwlr-lang', 'mi')
        } else {
          window.localStorage.removeItem('mwlr-lang')
        }
      } catch (error) {
        console.log(error)
      }
    }
  }
}
export default teReo
